import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { MuRouteDeliveriesData } from 'src/app/components/shared/models/interface/muRouteDeliveriesData.interface';
import { CityShared } from '../../../shared/models/interface/cityShared.interface';
import { City, Company, Country } from 'src/app/components/shared/models/interface/parametrizacion.interface';
import { ItemNumberToFilterShared } from '../../../shared/models/interface/itemNumberToFilter.interface';
import { ToastDataShared } from '../../../shared/models/interface/toastData.interface';
import { MuToastService } from 'src/app/components/shared/sharedServices/mu-toast.service';
import { MassiveService } from '../../massive.service';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { MassiveNewRoutingSearchFlags } from './massive-new-routing-search.flags';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { environment } from 'src/environments/environment';
import { ClientPointCompany } from 'src/app/components/massive/models/clientPointCompany.interface';


@Component({
  selector: 'app-massive-new-routing-search',
  templateUrl: './massive-new-routing-search.component.html',
  styleUrls: ['./massive-new-routing-search.component.sass'],
  providers: []
})
export class MassiveNewRoutingSearchComponent extends MuComponent {
  
  countries: Country[];
  coutriesListInput: ItemNumberToFilterShared[];
  selectedCountry: Country;

  cities: CityShared[];
  filteredCities: City[] = [];
  citiesListInput: ItemNumberToFilterShared[];
  selectedCity: CityShared;

  companies: Company[];
  companiesListInput: ItemNumberToFilterShared[];
  selectedCompany: Company;

  cediPoints: ClientPointCompany[];
  cediPointsListInput: ItemNumberToFilterShared[];
  selectedCediPoint: ClientPointCompany;
  
  formData: UntypedFormGroup;
  toastData: ToastDataShared;
  flagList: Flags<MassiveNewRoutingSearchFlags> = new Flags<MassiveNewRoutingSearchFlags>();
  massiveNewRoutingSearchFlags = MassiveNewRoutingSearchFlags;
  showModalCedi = false;

  constructor(
    private formGroup: UntypedFormBuilder, 
    private muToastService: MuToastService,
    private massiveService: MassiveService,
    private router: Router
  ) {
    super();
  }
  
  muOnInit(): void {
    this.initData();
    this.whatchForDropdownSelectEvents();
    this.watchFlags();
  }

  /**
   * @description This method is used initialize data used in the component
   * @returns void
   */
     initData(): void{
      this.getCountries();
      this.formData = this.formGroup.group({
        country: ['', Validators.required],
        cityNewRouting: ['', Validators.required],
        company: ['', Validators.required],
        cediPoint: ['', Validators.required],
      });
      this.toastData = environment.toastData;
    }
  
  /**
   * @description This method is used to watch dropdown select events
   * @returns void
   */
  whatchForDropdownSelectEvents(): void {
    this.watchFormCountrySelect();
    this.watchFormCitySelect();
    this.watchFormCompanySelect();
    this.watchFormCediSelect();
  }

  /**
   * @description This method is used to watch the flag changes
   * @returns void
   */
  watchFlags(): void {
    this.watch(this.flagList.valueChanges(this.massiveNewRoutingSearchFlags.CREATE_CEDI_MODAL)).subscribe(async flag => {
      this.showModalCedi = !this.showModalCedi;
      flag.toggle();
    });

    this.watch(this.flagList.valueChanges(this.massiveNewRoutingSearchFlags.CONTINUE_TO_DELIVERIES)).subscribe(async flag => {
      this.continueToDeliveries();
      flag.toggle();
    });
  }
  
  /**
   * @description This method manage the action excecuted from massiveNewRoutingSearchFlags.CONTINUE_TO_DELIVERIES flag
   * @returns void
   */
  continueToDeliveries(): void {
    this.router.navigate(['/masivos/deliveries/'], { state: MuRouteDeliveriesData({ 
      breadcrumb: this.selectedCountry?.name + ',' + this.selectedCity?.name + ',' + this.selectedCompany?.name + ',' + this.selectedCediPoint?.name,
      country: this.selectedCountry, 
      city: this.selectedCity, 
      company: this.selectedCompany, 
      cedi: this.selectedCediPoint 
    }) });
  }

  /**
   * @description Manage the closecedimodal event from app-create-cedi-point template
   * @returns void
   */
  handleModalCedi(): void {
    this.showModalCedi = !this.showModalCedi;
  }
  
  /**
   * @description Manage the showtoast event from app-create-cedi-point template
   * @returns void
   */
  showSuccess(): void {
    this.muToastService.showSpecificToast({
      key: 'toast-layout-viewDetail',
      severity: 'success',
      summary: 'toast.massive.success.title',
      detail: 'toast.massive.success.cediCreation',
      life: this.toastData.life,
    });
    this.getCediPoints(this.formData.controls.company.value, this.formData.controls.cityNewRouting.value);
  }

  /**
   * @description This method is used to whatch for the city selection from the form
   * @returns void
   */
  watchFormCountrySelect(): void {
    this.watch(this.formData.get('country').valueChanges).subscribe(async value => {
      this.cediPoints = null; 
      this.cediPointsListInput = null;
      this.getCities(value);
      this.getCompanies(value);
      this.selectedCountry = this.getObjectFromList(this.countries, value, 'iso2');
    });
  }

  /**
   * @description This method is used to whatch for the city selection from the form
   * @returns void
   */
  watchFormCitySelect(): void {
    this.watch(this.formData.controls.cityNewRouting.valueChanges).subscribe(value => {
      this.selectedCity = this.getObjectFromList(this.cities, value, 'id');
      this.getCediPoints(this.formData.controls.company.value, value);
    });
  }
  
  /**
   * @description This method is used to whatch for the company selection from the form
   * @returns void
   */
  watchFormCompanySelect(): void {
    this.watch(this.formData.controls.company.valueChanges).subscribe(value => {
      this.getCediPoints(value, this.formData.controls.cityNewRouting.value);
      this.selectedCompany = this.getObjectFromList(this.companies, value, 'id');
    });
  }
  
  /**
   * @description This method is used to whatch the cedi selection from the dropdown
   * @returns void
   */
  watchFormCediSelect(): void {
    this.watch(this.formData.controls.cediPoint.valueChanges).subscribe(value => {
      this.selectedCediPoint = this.getObjectFromList(this.cediPoints, value, 'id');
    });
  }

  /**
   * @description This method is used to get countries
   * @returns void
   */ 
  getCountries(): void{
    this.massiveService
    ?.getListCountries()
    ?.then(res => {
        this.countries = res; 
        this.coutriesListInput = this.convertToItemNumberToFilterSharedArray(this.countries, 'iso2');
      })
    ?.catch(e => {
      this.muToastService.showSpecificToast({
        exception: e,
        key: 'toast-layout-viewDetail',
        severity: 'error',
        detail: 'toast.delivery.error.city.title',
        summary: 'toast.delivery.error.city.text',
        life: this.toastData.life,
      });
      throw e;
    });
  }

  /**
   * @description This method is used to get cities from the selected country
   * @param countryIso2: string
   * @returns void
   */ 
  getCities(countryIso2: string):void{
    this.massiveService
    ?.getListCities(countryIso2)
    ?.then(res => {
       this.cities = res; 
       this.citiesListInput = this.convertToItemNumberToFilterSharedArray(this.cities);
      })
    ?.catch(e => {
      this.muToastService.showSpecificToast({
        exception: e,
        key: 'toast-layout-viewDetail',
        severity: 'error',
        detail: 'toast.delivery.error.city.title',
        summary: 'toast.delivery.error.city.text',
        life: this.toastData.life,
      });
      throw e;
    });
  }

  /**
   * @description get cedi companies
   * @param countryIso2: string
   * @returns void
   */
  getCompanies(countryIso2: string): void{
    this.massiveService
    ?.getListCompanies(countryIso2)
    ?.then(res => {
       this.companies = res; 
       this.companiesListInput = this.convertToItemNumberToFilterSharedArray(this.companies);
      })
    ?.catch(e => {
      this.muToastService.showSpecificToast({
        exception: e,
        key: 'toast-layout-viewDetail',
        severity: 'error',
        detail: 'toast.delivery.error.city.title',
        summary: 'toast.delivery.error.city.text',
        life: this.toastData.life,
      });
      throw e;
    });
  }

  /**
   * @description get cedi points
   * @param companyId: number 
   * @returns coid
   */
  getCediPoints(companyId: number, cityId: number): void {
    this.massiveService
    ?.getListCediPionts(companyId, cityId)
    ?.then(res => {
       this.cediPoints = res; 
       this.cediPointsListInput = this.convertToItemNumberToFilterSharedArray(this.cediPoints);
      })
    ?.catch(e => {
      this.muToastService.showSpecificToast({
        exception: e,
        key: 'toast-layout-viewDetail',
        severity: 'error',
        detail: 'toast.delivery.error.city.title',
        summary: 'toast.delivery.error.city.text',
        life: this.toastData.life,
      });
      throw e;
    });
  }
  
  /**
   * @description This methos is used to filter cities from search form input
   * @param $event 
   * @returns void
   */
  filterCities($event):void {
    this.filteredCities = [];
    this.cities.forEach(city => {
      if (city.name.toLowerCase().indexOf($event.query.toLowerCase()) === 0) {
        this.filteredCities.push(city);
      }
    });
  }

  /**
   * @description convert an array of number to an array of ItemNumberToFilterShared
   * @param array: Array<any>
   * @param valueTag: string
   * @returns ItemNumberToFilterShared
   */
  convertToItemNumberToFilterSharedArray(array: any[], valueTag:string='id'): ItemNumberToFilterShared[]{
    return array.map(item => {
      return {
        value: item[valueTag],
        label: item.name
      }
    });
  }

  
  /**
   * 
   * @description find the object from a list of objects and a key given
   * @param list: Array<any>
   * @param value: string
   * @param key: string
   * @returns findedItem
   */
  getObjectFromList(list: any[], value: string, key: string): any {
    return list.find(item => item[key] === value);
  }
  
  muOnDestroy(): void {
    /** */
  }

}
